import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

interface Player {
  email: string;
  name: string;
  phone?: string;
  interest?: string;
  company: string;
  id: string;
}

export interface Score {
  moves: number;
  player: Player;
}

interface LeaderboardProps {
  scores: Score[];
}

const Leaderboard: React.FC<LeaderboardProps> = ({ scores }) => {
  const topScores = scores.sort((a, b) => a.moves - b.moves).slice(0, 10);

  const maskEmail = (email: string) => {
    if (!email || !email.includes('@')) {
      return 'N/A';
    }
    const [username, domain] = email.split('@');
    if (!username || !domain) {
      return 'N/A';
    }
    const maskedUsername = username.charAt(0) + '*'.repeat(Math.max(0, username.length - 1));
    return `${maskedUsername}@${domain}`;
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Top 10 Players
      </Typography>
      <List>
        {topScores.map((score, index) => (
          <ListItem key={index} divider>
            <ListItemText
              primary={`${score.player.name} (${maskEmail(score.player.email)})`}
              secondary={`Moves: ${score.moves}`}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Leaderboard; 